module.exports = __webpack_public_path__ + "img/107048.b39d6aef.png";